import { inject, observer } from "mobx-react";
import { Component } from "react";
import { FormattedMessage, type IntlShape, injectIntl } from "react-intl";
import { compose } from "nvent-web/utils/compose";

import RoomForm from "nvent-web/components/RoomForm";
import * as logger from "nvent-web/services/logger";
import { NotificationsStore } from "nvent-web/stores/Notifications";
import { RoomsStore } from "nvent-web/stores/Rooms";
import { type NewRoomFormValues } from "nvent-web/types/NewRoomFormValues";
import { withRouter, type WithRouterProps } from "~/nvent-web/utils/withRouter";

interface AddRoomsParams {
  projectId: string;
}

interface AddRoomFormInnerProps extends AddRoomsParams, WithRouterProps {
  intl: IntlShape;
  rooms: RoomsStore;
  notifications: NotificationsStore;
}

const initialValues: NewRoomFormValues = {
  name: "",
  area: null,
  installableArea: null,
  floorConstruction: null,
  floorFinish: null,
  areaType: "dry",
};

class AddRoomFormInner extends Component<AddRoomFormInnerProps> {
  render() {
    return (
      <RoomForm
        isSubmitting={this.props.rooms.isRoomCreating}
        onCancel={this.handleCancel}
        initialValues={initialValues}
        handleSubmit={this.handleSubmit}
      />
    );
  }

  private handleCancel = () => {
    this.props.navigate(-1);
  };

  private handleSubmit = (formValues: NewRoomFormValues) => {
    try {
      const { rooms } = this.props;
      const levelIdSearchParam = new URLSearchParams(location.search).get(
        "levelId"
      );
      const levelId = levelIdSearchParam
        ? parseInt(levelIdSearchParam, 10)
        : undefined;

      rooms.createRoom({
        values: formValues,
        projectId: Number(this.props.params.projectId),
        levelId,
      });
    } catch (err) {
      logger.error(err);
      this.props.notifications.createError(
        <FormattedMessage id="error.createRoomFailed" />
      );
    }
  };
}

const AddRoomForm = compose(
  injectIntl,
  withRouter,
  inject("rooms", "notifications"),
  observer
)(AddRoomFormInner);

export default AddRoomForm;
